var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgThinkoLogo = function SvgThinkoLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 191 192",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M178.872 138.524C179.811 139.003 180.964 138.631 181.424 137.681C190.957 118.03 193.474 95.6833 188.519 74.3718C183.419 52.4395 170.734 33.0146 152.703 19.5272C134.672 6.0397 112.455 -0.642709 89.9755 0.659941C67.4959 1.96259 46.1996 11.1665 29.8471 26.6464C13.4947 42.1263 3.13805 62.8865 0.605967 85.261C-1.92611 107.635 3.52927 130.185 16.0088 148.928C28.4883 167.671 47.1892 181.401 68.8092 187.694C89.8172 193.809 112.268 192.52 132.412 184.078C133.385 183.67 133.82 182.54 133.393 181.576C132.966 180.611 131.839 180.178 130.865 180.584C111.545 188.663 90.0201 189.89 69.8768 184.026C49.1216 177.985 31.1688 164.804 19.1884 146.811C7.20811 128.818 1.97094 107.17 4.40174 85.6906C6.83253 64.211 16.7749 44.2813 32.4733 29.4206C48.1716 14.5598 68.616 5.72409 90.1965 4.47354C111.777 3.223 133.105 9.63811 150.415 22.5861C167.725 35.534 179.903 54.182 184.798 75.2369C189.549 95.6712 187.145 117.097 178.02 135.945C177.561 136.895 177.932 138.045 178.872 138.524Z",
    fill: "url(#paint0_linear_1122_43361)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M151.218 96C151.218 126.767 126.277 151.708 95.5101 151.708C64.7432 151.708 39.8018 126.767 39.8018 96C39.8018 65.2331 64.7432 40.2917 95.5101 40.2917C126.277 40.2917 151.218 65.2331 151.218 96ZM45.3726 96C45.3726 123.69 67.8199 146.137 95.5101 146.137C123.2 146.137 145.648 123.69 145.648 96C145.648 68.3098 123.2 45.8625 95.5101 45.8625C67.8199 45.8625 45.3726 68.3098 45.3726 96Z",
    fill: "url(#paint1_linear_1122_43361)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0512 82.8905C18.8868 82.5094 16.8129 83.9547 16.5404 86.1354C14.3879 103.364 17.9268 120.866 26.6781 135.946C36.0966 152.175 50.9469 164.555 68.6066 170.898C86.2663 177.241 105.599 177.141 123.192 170.614C140.785 164.087 155.505 151.553 164.754 135.227C174.003 118.9 177.186 99.8304 173.74 81.3851C170.294 62.9398 160.441 46.3054 145.922 34.4192C131.402 22.533 113.149 16.1597 94.3865 16.4246C76.9532 16.6707 60.1217 22.6332 46.4509 33.3365C44.7205 34.6913 44.5471 37.2132 45.9866 38.8737C47.4261 40.5342 49.933 40.7035 51.6709 39.3584C63.9178 29.8791 78.9421 24.6018 94.4989 24.3821C111.385 24.1437 127.813 29.8797 140.88 40.5773C153.948 51.2748 162.816 66.2458 165.917 82.8466C169.018 99.4474 166.154 116.61 157.83 131.304C149.506 145.998 136.257 157.278 120.424 163.152C104.59 169.027 87.1906 169.117 71.2969 163.408C55.4032 157.699 42.0379 146.558 33.5613 131.951C25.752 118.495 22.5546 102.895 24.3892 87.5169C24.6495 85.3347 23.2155 83.2716 21.0512 82.8905Z",
    fill: "url(#paint2_linear_1122_43361)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1122_43361",
    x1: 0.000257035,
    y1: 3.32536,
    x2: 191,
    y2: 188.675,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#AB5A03"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#E8AF0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#E8AF0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#AB5A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1122_43361",
    x1: 61.1465,
    y1: 40.2917,
    x2: 129.874,
    y2: 151.708,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#A65301"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#8F3E47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#F2BB05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8F3E47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1122_43361",
    x1: 24.7626,
    y1: 16.4167,
    x2: 166.258,
    y2: 175.583,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#8F3E47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#CC8703"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#F2BB05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#8F3E47"
  })))));
};
export default SvgThinkoLogo;